import React from 'react'

const TutionFee = () => {
  return (
    <div>TutionFee</div>
  )
}

export default TutionFee